import FacebookIcon from '@/components/icons/FacebookIcon';
import TiktokIcon from '@/components/icons/TiktokIcon';
import InstagramIcon from '@/components/icons/InstagramIcon';
import GoogleIcon from '@/components/icons/GoogleIcon';
import Title from '@/components/ui/Title';
import type { ReactNode } from 'react';
import { useWebinarT } from '@/hooks/useWebinarT';
import XIcon from '@/components/icons/XIcon';
import LinkedinIcon from '@/components/icons/LinkedinIcon';
import SnapchatIcon from '@/components/icons/SnapchatIcon';
import YoutubeIcon from '@/components/icons/YoutubeIcon';
import TwitchIcon from '@/components/icons/TwitchIcon';
import WhatsappIcon from '@/components/icons/WhatsappIcon';
import PinterestIcon from '@/components/icons/Pinteresticon';

import DialogAddSocial from './DialogAddSocial';
import MySocialsMedia from './MySocialsMedia';

interface SocialMediaOption {
  value: string;
  label: string;
  icon?: ReactNode;
}

export const socialMediaOptions: SocialMediaOption[] = [
  {
    value: 'FACEBOOK',
    label: 'Facebook',
    icon: <FacebookIcon size={24} />,
  },
  {
    value: 'INSTAGRAM',
    label: 'Instagram',
    icon: <InstagramIcon size={24} />,
  },
  {
    value: 'TIKTOK',
    label: 'TikTok',
    icon: <TiktokIcon size={24} />,
  },
  {
    value: 'X',
    label: 'X',
    icon: <XIcon size={24} />,
  },
  {
    value: 'GOOGLE',
    label: 'Google',
    icon: <GoogleIcon size={24} />,
  },
  {
    value: 'PINTEREST',
    label: 'Pinterest',
    icon: <PinterestIcon size={24} />,
  },
  {
    value: 'LINKEDIN',
    label: 'Linkedin',
    icon: <LinkedinIcon size={24} />,
  },
  {
    value: 'SNAPCHAT',
    label: 'Snapchat',
    icon: <SnapchatIcon size={24} />,
  },
  {
    value: 'YOUTUBE',
    label: 'Youtube',
    icon: <YoutubeIcon size={24} />,
  },
  {
    value: 'TWITCH',
    label: 'Twitch',
    icon: <TwitchIcon size={24} />,
  },
  {
    value: 'WHATSAPP',
    label: 'WhatsApp',
    icon: <WhatsappIcon size={24} />,
  },
];

export default function SocialMediaSection() {
  const { t } = useWebinarT('webinars');

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <Title level={2}>{t('socialMedia.title')}</Title>
        <DialogAddSocial />
      </div>
      <MySocialsMedia />
    </div>
  );
}
